import Component from '../core/Component'
import countries from '../utils/countries'
import { lang } from '../core/config'
import debounce from 'lodash/debounce'

const STATES = {
    VISIBLE: 'is-visible'
}

export default class ServiceMapBubble extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            content: null
        }

        this.isVisible = false
        this.canHide = false

        this.toggle = debounce(this.toggle.bind(this), 200)

    }

    prepare() {

    }

    update({
        x,
        y,
        code
    }) {
        this.element.style.transform = `translate(${x}px, ${y}px)`
        this.ref.content.textContent = countries[lang][code]

        if (!this.isVisible) {
            this.show()
        }
    }

    toggle() {
        if (this.isVisible) {
            this.hide()
        } else {
            this.show()
        }
    }

    show() {
        this.isVisible = true
        this.element.classList.add(STATES.VISIBLE)
    }

    hide() {
        this.isVisible = false
        this.element.classList.remove(STATES.VISIBLE)
    }
}




// WEBPACK FOOTER //
// ./components/ContactMapBubble.js